/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const updateIntegrationInstanceRequestSchema = z.object({
  credentialsId: z.int().nullish(),
  instanceId: z.string().nullish(),
  instanceName: z.string().nullish(),
  instanceUrl: z.string().nullish(),
});
